import { connect } from 'react-redux';
import CreateInvoice from '../../../../views/Finance/Spp/CreateInvoice/CreateInvoice.view';
import { saveNotifProcess, listNotifProcess, listStudentInvoice } from '../../../../states/thunks/academics.thunk';
import { getPeriodsOptions, getPrmLevels, getClassesOptions, getParamOptionsAcademics } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  }
}

function mapDispatchToProps(dispatch) {
  return {
    handleSaveNotifProcess: (payload, goback) => dispatch(saveNotifProcess(payload, goback)),
    handleListNotifProcess: (payload, goback) => dispatch(listNotifProcess(payload, goback)),
    handleListStudentInvoice: (payload, goback) => dispatch(listStudentInvoice(payload, goback)),
    getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
    getClassesOptions: (payload) => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateInvoice);
